module.exports = __webpack_public_path__ + "static/media/user-21.9ba10ee5.png";